import PropTypes from 'prop-types'
import { components } from 'react-select'

import DirectionIcon from '../DirectionIcon'

const CustomIndicators = ({ children, ...props }) => {
  return (
    <components.IndicatorsContainer {...props}>
      <DirectionIcon {...props} />
      {children}
    </components.IndicatorsContainer>
  )
}

CustomIndicators.propTypes = {
  children: PropTypes.node,
}

export default CustomIndicators
